import { Auth } from 'aws-amplify';
import axios from 'axios';

import { EMAIL_API_BASE_URL } from './email-api-url';

export const sendEmailBatch = async ({
  orgId,
  userId,
  name,
  subject,
  content,
  emails,
  orgName,
  media_url,
  media_file_name,
}) => {
  const body = {
    orgId,
    userId,
    name,
    subject,
    content,
    recipients: emails,
    orgName,
    media_url,
    media_file_name,
  };
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return new Promise((resolve, reject) => {
    axios
      .post(`${EMAIL_API_BASE_URL}/email/send-batch`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
